{
  "slug": "logic-puzzles",
  "title": "Logic Puzzles: Methods That Transfer",
  "description": "Externalize constraints and test assumptions.",
  "category": "Brain training",
  "sections": [
    {
      "heading": "What to train",
      "paragraphs": [
        "Externalize constraints and test assumptions.",
        "Specific practice transfers most strongly to similar tasks; broad-transfer claims need caution."
      ]
    },
    {
      "heading": "Exercises",
      "paragraphs": ["Increase difficulty only when accuracy is stable."],
      "bullets": [
        "Build truth tables.",
        "Draw ordered slots.",
        "Mark definite, possible, impossible.",
        "Check every clue."
      ]
    },
    {
      "heading": "Sustainable routine",
      "paragraphs": [
        "Use brief regular sessions, adequate sleep, movement, and recovery.",
        "Track accuracy and difficulty rather than expecting a guaranteed IQ increase."
      ]
    }
  ],
  "related": ["can-iq-change-over-time", "working-memory-explained", "processing-speed-explained"],
  "sources": [],
  "faqs": [],
  "summary": "Externalize constraints and test assumptions. Content reviewed 18 July 2026."
}
